export const initialState = {
  inquery: {
    answers: {},
    activeIndex: 0,
    contrast: false,
    fontSize: false,
    defaultValues: {},
  },
  reports: {
    name: '',
    testSymbol: null,
    normScale1: { value: 'PERCENTILE', label: 'centyle' },
    normScale2: { value: 'RECALC', label: 'wyników przeliczonych' },
    confidenceInterval: { value: 'MEDIUM', label: '90%' },
    personalDataVisible: true,
    testInfoVisible: true,
    resultsTableVisible: true,
    resultsChartVisible: true,
    testProtocolVisible: true,
    resultInterpretationVisible: false,
    resultInterpretation: '',
  },
  aggregateReports: {
    name: '',
    normScale1: { value: 'PERCENTILE', label: 'centyle' },
    normScale2: { value: 'RECALC', label: 'wyników przeliczonych' },
    confidenceInterval: { value: 'MEDIUM', label: '90%' },
    personalDataVisible: true,
    testsInfoVisible: true,
    testsResultsVisible: true,
    areasResultsVisible: true,
    testsChartVisible: true,
    areasChartVisible: true,
    interprofileChartVisible: true,
    icfReferenceVisible: true,
    postdiagnosticVisible: true,
    resultsInterpretationVisible: false,
    resultsInterpretation: '',
  },
  inqueryReports: {
    name: '',
    normScale: { value: 'PERCENTILE', label: 'centyle' },
    confidenceInterval: { value: 'MEDIUM', label: '90%' },
    personalDataVisible: true,
    respondentsDataVisible: true,
    resultsRelatedToPopulationVisible: true,
    resultsRelatedToDisabilityVisible: true,
    inquiriesProtocolVisible: true,
    icfReferenceVisible: true,
    postdiagnosticVisible: true,
    resultsInterpretationVisible: false,
    resultsInterpretation: '',
  },
}
